(function() {
    document.addEventListener("DOMContentLoaded", function() {
        document.addEventListener("click", function(e) {
            var clicked = e.target;
            while (!clicked.classList?.contains("js-showSources")) {
                clicked = clicked.parentNode;
                if (!clicked) return;
            }
            e.preventDefault();

            var target_id = clicked.getAttribute("data-target"),
                wrapper = document.getElementById(target_id),
                toggle = wrapper.querySelector(".c-sources__toggle"),
                list = wrapper.querySelector(".c-sources__list"),
                list_height = list?.offsetHeight;

            wrapper.style.overflow = "visible";
            wrapper.style.height = list_height + "px";
            wrapper.classList.add("is-active");
            wrapper.classList.toggle("c-sources__list-hidden");

            setTimeout(function() {
                toggle.parentNode.removeChild(toggle);
                wrapper.style.height = "auto";
            }, 200);
        });
    });
})();
